const ADMIN_ROLE_TOKENS = new Set(['systemadmin']);

function normalizeRoleValue(value) {
  if (value === undefined || value === null) {
    return '';
  }

  return String(value).trim();
}

function normalizeAccessToken(value) {
  return normalizeRoleValue(value)
    .toLowerCase()
    .replace(/[\s_-]+/g, '');
}

function extractRoleValues(entry) {
  if (entry === undefined || entry === null) {
    return [];
  }

  if (typeof entry === 'string' || typeof entry === 'number') {
    const normalized = normalizeRoleValue(entry);
    return normalized ? [normalized] : [];
  }

  if (typeof entry === 'object') {
    return [
      entry.name,
      entry.role,
      entry.roleName,
      entry.code,
      entry.type,
      entry.key,
      entry.value,
    ]
      .map(normalizeRoleValue)
      .filter(Boolean);
  }

  return [];
}

function extractRoleValuesFromCollection(collection) {
  if (collection === undefined || collection === null) {
    return [];
  }

  const values = Array.isArray(collection) ? collection : [collection];
  return values.flatMap(extractRoleValues);
}

export default function hasAdminSafeZoneAccess(user) {
  if (!user) {
    return false;
  }

  if (user.isSystemAdmin) {
    return true;
  }

  const roleValues = extractRoleValuesFromCollection(user.roles);
  return roleValues.some((role) =>
    ADMIN_ROLE_TOKENS.has(normalizeAccessToken(role))
  );
}
